/**
 * Compares the children of list items
 * Return true if props are equal, return false otherwise
 * @method areListItemsEqual
 */
const areListItemsEqual = (prevChildren, nextChildren, propsToCompare) => {
  if (prevChildren?.length !== nextChildren?.length) {
    return false;
  }

  const areChildrenUnequal = (prevChild, index) => {
    const nextChild = nextChildren[index];

    return propsToCompare.some(
      (prop) => prevChild?.[prop] !== nextChild?.[prop],
    );
  };

  if (prevChildren.some(areChildrenUnequal)) {
    return false;
  }

  return true;
};

export default areListItemsEqual;
